import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Shared/Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlanCalendarService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async GetNearByBusiness(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetNearByBusiness`,obj,isformupload);    
}


async addCalendar(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanNotificationCount`,obj,isformupload);    
}

async GetPlanListViewDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanCalendarViewDetails`,obj,isformupload);    
}

async GetPlanCalendarCountDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanCalendarCountDetails`,obj,isformupload);    
}

async GetPlanListLoadMoreViewDetails(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanCalendarLoadMoreViewDetails`,obj,isformupload);    
}

async GetPlanNotificationList(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanNotificationList`,obj,isformupload);    
}

async GetLocation() {
  return await this.api.getLocation();    
}

async GetPlanResonDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanResonDropdownListValues`,obj,isformupload);    
}

async PlanListEventUpdate(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/PlanListEventUpdate`,obj,isformupload);    
}
async PlanListEventGetUpdate(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanCalendarViewDetailsUpdate`,obj,isformupload);    
}

async PlanListEventGetUpdateV1(obj:any,isformupload:boolean) {
  return this.api.apiPost(false, `SalesLogin/GetPlanCalendarViewDetailsUpdateV1`,obj,isformupload);    
}

}
